import script from "./sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=fef416a6&lang=scss&scoped=true"

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fef416a6"]])

export default __exports__